import { z } from 'zod'

/**
 * An id this app stores. Every record id is a UUID; route params and request
 * bodies both have to accept the same strings, so there is one schema.
 */
export const uuidSchema = z.string().uuid()

/**
 * A route or query value that is an id, or null when it is missing or not.
 *
 * Callers that would otherwise send the raw param to the API use this first.
 * A failed parse is "not found", not a request the server has to refuse.
 */
export function parseUuid(value: string | null | undefined): string | null {
  const parsed = uuidSchema.safeParse(value)
  return parsed.success ? parsed.data : null
}
